import React from 'react';
import ImageGallerytechnicalcenter from '../components/ImageGallerytechnicalcenter';
import IRCTVDonationCard from "./IRCTVDonationCard";
import { useStats } from '../hooks/useStats';

const IRCTECHNICAL = () => {
    const technicalBaseAmount = 300;

  const { stats, loading } = useStats();

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '31-Jan-2025';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format number with commas
  const formatNumber = (num) => {
    if (!num && num !== 0) return 'Loading...';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <>
      <div className="about-us-container">
        <section className="activities-details">
          <button
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>
          <div className="activity-intro">
            <h2>OUR ACTIVITIES</h2>
            <p>All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities</p>
          </div>
          <ImageGallerytechnicalcenter />

          {/* IRC Technical Institutes */}
          <div className="activity-card">
            <div className="activity-header">
              <h3>IRC TECHNICAL INSTITUTES (ITI)</h3>
            </div>
            <div className="activity-content">
              <p>Building Skilled Futures Through Free Technical Education
                For many underprivileged youth, access to technical education remains out of reach due to high costs and limited opportunities. IRC Technical Institutes (ITI) were established to break this barrier. With four centers across Baijipura, Lasur, Khuldabad, and Fazilpura, IRC has provided free skill-based training to 985 students as of July 2025.
                Each institute offers industry-relevant courses tailored to local needs. Students are trained in electrical maintenance, mobile and electronic gadget repair, AC servicing, tailoring, cake making, fashion designing, and computer literacy—all under the guidance of skilled instructors. Our latest center in Fazilpura offers cutting-edge IT training in fields like Data Science, AI, Digital Marketing, and Full Stack Development, opening doors to professional tech careers even for students from modest backgrounds.
                Every course completed brings a student closer to self-reliance, income stability, and dignity. Your support helps us equip them with tools not just for employment, but for transformation. Invest in skills, and you invest in futures.
              </p>

              <div className="clinic-card">
                <h4>Institute - 1 - Baijipura</h4>
                <p><strong>Name:</strong> IRC Technical Institute</p>
                <p><strong>Address:</strong> 3rd Floor, IRC Community Centre, Gali No 34, Behind Sikandar Function Hall, Apex Hospital Road, Baijipura, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Technical+Institute+Baijipura/@19.8829887,75.3299701,2446m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3bdba3efc0999943:0x2464e4556f5622ce!8m2!3d19.8829695!4d75.3484242!16s%2Fg%2F11jt251xr5?entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=a4615f86-657e-4861-9a90-89b56d6bf33b" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 07-Jan-2020</p>
                <p><strong>Courses Offered:</strong> Mobile Repair, Electronic Gaget Repair, Electrician, AC Repair etc.</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.technical_baijipura_students)} (till {formatDisplayDate(stats.technical_baijipura_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('9112-9112-05')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    9112-9112-05
                  </span>
                </p>
              </div>

              <div className="clinic-card">
                <h4>Institute - 2 - Lasur</h4>
                <p><strong>Name:</strong> IRC Technical Institiute</p>
                <p><strong>Address:</strong> Gopinath Nagar, Mata Ramai Ambedkar Pravesh Dwar, Lasur Station, LASUR - 423702, Tal - Gangapur, Dist - Chhatrapati Sambhajinagar (Aurangabad)</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Technical+Institute+Lasur/@19.9289713,75.005898,611m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3bdb8921f6b12b5f:0xbfdd9710f25dd977!8m2!3d19.9289663!4d75.0084729!16s%2Fg%2F11tf4zxr36?entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=e3672ee5-e8ed-464b-944c-186605fbe541" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 14-Sep-2021</p>
                <p><strong>Courses Offered:</strong> Tailoring, Fashion Designing, Mehendi, Caligraphy, Cake Making etc.</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.technical_lasur_students)} (till {formatDisplayDate(stats.technical_lasur_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('9112-9112-03')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    9112-9112-03
                  </span>
                </p>
              </div>

              <div className="clinic-card">
                <h4>Institute - 3 - Khuldabad</h4>
                <p><strong>Name:</strong> IRC Technical Institiute</p>
                <p><strong>Address:</strong> Munam Masjid, Old Bus Stand, KHULDABAD - 431101, Dist - Chhatrapati Sambhajinagar (Aurangabad)</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Technical+Institute+Khuldabad/@20.0075599,75.1899006,611m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3bdb93d0d73df047:0x56b4d9ca94372130!8m2!3d20.0075549!4d75.1924755!16s%2Fg%2F11j_1ydvqy?authuser=0&entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=c8c29916-55b3-4d67-9a90-fc03796a27c1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 03-Feb-2022</p>
                <p><strong>Courses Offered:</strong> Tailoring, Fashion Designing, Mehendi, Caligraphy, Cake Making etc.</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.technical_khuldabad_students)} (till {formatDisplayDate(stats.technical_khuldabad_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('9112-9112-04')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    9112-9112-04
                  </span>
                </p>
              </div>

                 <div className="clinic-card">
                <h4>Institute - 4 - Fazilpura</h4>
                <p><strong>Name:</strong> IRC Technical Institiute</p>
                <p><strong>Address:</strong> IRC Community Center, Plot No.21,
Near Collector office, Fazil Pura,
(Aurangabad - 431001)</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Technical+Institute+-+Digital+Marketing+and+Software+development+institute/@19.8910247,75.341228,3a,75y,90t/data=!3m8!1e2!3m6!1sAF1QipNuAqRBc7wDM8FhSHPEy5sp8EN_WGjw7akeLhvb!2e10!3e12!6shttps:%2F%2Flh3.googleusercontent.com%2Fp%2FAF1QipNuAqRBc7wDM8FhSHPEy5sp8EN_WGjw7akeLhvb%3Dw203-h152-k-no!7i1280!8i960!4m21!1m13!4m12!1m4!2m2!1d75.776!2d21.0468864!4e1!1m6!1m2!1s0x3bdba3ae8937e945:0x9051d4f27cfc2804!2sIRC+Technical+Institute+-+Digital+Marketing+and+Software+development+institute,+Plot+No.+21,+near+Collector+Office+Road,+Fazalpura,+Sharif+Colony,+Jaswantpura,+Chhatrapati+Sambhajinagar,+Maharashtra+431001!2m2!1d75.3413435!2d19.8910123!3m6!1s0x3bdba3ae8937e945:0x9051d4f27cfc2804!8m2!3d19.8910123!4d75.3413435!10e5!16s%2Fg%2F11mrxn2g4q?entry=ttu&g_ep=EgoyMDI2MDQwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 03-Feb-2022</p>
                <p><strong>Courses Offered:</strong> Professional IT Courses (AWS, Cloud Computing, Digital Marketing, Data Analytics, Infrastructure and Support Engineer (L1/L2), AI Content Creation, Graphic Designing).</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.technical_khuldabad_students)} (till {formatDisplayDate(stats.technical_khuldabad_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('9607-05-2142')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    9607-05-2142
                  </span>
                </p>
              
                 <p>
                  <strong>WhatsApp: </strong>
                  <a className="contact-number" href="https://wa.me/9112911207" target="_blank" rel="noreferrer" style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                  9112-9112-07
                </a>
                </p>

                  <p>
                  <strong>Visit Website: </strong>
                  <a className="contact-number" href="https://ircti.com/" target="_blank" rel="noreferrer" style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                  ircti.com
                </a>
                </p>
              </div>


              <div className="benefits-breakdown">
                <h4>What Your Donation Provides</h4>
                <div className="benefits-grid">
                  <div className="benefit-item">
                    <span className="benefit-icon">🧵</span>
                    <span className="benefit-text">Tailoring & Fashion Training</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">🎨</span>
                    <span className="benefit-text">Calligraphy & Mehendi Classes</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">🍰</span>
                    <span className="benefit-text">Baking & Cooking Skills</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">📚</span>
                    <span className="benefit-text">Educational Materials</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">🕌</span>
                    <span className="benefit-text">Islamic Studies & Arabic</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">💼</span>
                    <span className="benefit-text">Career Counseling</span>
                  </div>
                </div>
              </div>
            </div>
            <IRCTVDonationCard
              title="IRC TECHNICAL INSTITUTES (ITI)"
              baseAmount={technicalBaseAmount}
              subtitle="Your donation makes a difference"
              description="Donate Us continue providing quality content and services to our community."
              amount="₹5000"
              purpose="Cause: IRC TECHNICAL INSTITUTES (ITI)"
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default IRCTECHNICAL;